<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between d-flex">
            {{ title }}
            <v-avatar
                color="primary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="step"
                v-if="step"
            />
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <div>{{ description }}</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-combobox-filled
                        :items="tags"
                        v-model="tag"
                        label="Etiquette"
                        small-chips
                        no-filter
                        hide-details
                        item-disabled
                        item-value="name"
                        :item-title="(item) => item.name"
                    />
                </v-col>
            </v-row>
            <v-row v-if="amountSigned <= 0">
                <v-col>
                    <oss-text-field-filled
                        :min="0"
                        label="Intérêts"
                        suffix="&#x20ac;"
                        v-model="loanInterest"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <oss-text-field-filled
                        :min="0"
                        label="Assurance"
                        suffix="&#x20ac;"
                        v-model="loanInsurance"
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">{{
                step ? "Précédent" : "Annuler"
            }}</v-btn>
            <v-spacer />
            <v-btn
                @click="addLoan"
                :loading="loading"
                :disabled="disabledAddLoanValidate()"
                size="small"
                >Valider</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import CREATE_LOAN from "../../graphql/reconciliation/CreateLoan.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["added", "cancel"],
})
export class Loan extends Vue {
    @Prop({ default: null }) step: any;
    @Prop({ default: null }) reconciliationVue: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) btItem: any;
    @Prop({ default: null }) actions: any;

    tag = "";

    loading: boolean = false;
    loanInterest = 0.0;
    loanInsurance = 0.0;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get title() {
        if (this.amountSigned > 0) {
            return "Valider l'emprunt";
        }
        return "Intérêts : Saisir les intérêts et l'assurance (facultatif)";
    }

    get description() {
        if (this.repayment > 0) return "Remboursement : " + newCommonFormatCurrency(this.repayment);
        if (this.repayment < 0) return "Prêt : " + newCommonFormatCurrency(-this.repayment);
        return "Sans remboursement";
    }

    get repayment() {
        let repayment = -this.amountSigned;
        if (this.amountSigned < 0) {
            repayment -= this.loanInterest;
            repayment -= this.loanInsurance;
        }
        return repayment;
    }

    get amountSigned() {
        if (this.btItem && this.btItem.accountingLine) {
            return -this.btItem.accountingLine.amountSigned;
        }
        return 0.0;
    }

    get bankTransaction() {
        if (this.btItem) return this.btItem.bt;
        return undefined;
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Valider";
            this.actions.action.disabled = () => {
                return !this.disabledAddLoanValidate;
            };
            this.actions.action.function = this.addLoan;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }
    }

    disabledAddLoanValidate() {
        if (this.amountSigned < 0) {
            if (this.repayment < 0) return true;
            if (this.loanInterest < 0) return true;
            if (this.loanInsurance < 0) return true;
            if (this.repayment + this.loanInterest + this.loanInsurance === 0) return true;
        } else if (this.repayment >= 0) return true;
        return false;
    }

    async addLoan() {
        this.loading = true;
        if (this.btItem) {
            await this.$apollo.mutate({
                mutation: CREATE_LOAN,
                variables: {
                    bankTransactionId: this.bankTransaction.id,
                    companyId: this.companyId,
                    interest: this.loanInterest,
                    insurance: this.loanInsurance,
                    repayment: this.repayment,
                    tagName: this.tag,
                },
            });

            await this.reconciliationVue.refresh();
            // }
            this.loanInterest = 0.0;
            this.loanInsurance = 0.0;
            this.$emit("added");
        }
        this.loading = false;
    }

    cancel() {
        this.$emit("cancel");
    }

    tags = [];
}

export default toNative(Loan);
</script>
